/**
 *
 * TimeSlot
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { SLOT_ASSIGNED, SLOT_BLOCKED, SLOT_BREAK, SLOT_OPEN, SLOT_CLASSNAMES } from '../../../constants.js';
import EventTime from './EventTime.jsx';
import messages from './messages.js';
import MeetingParticipants from '../../MeetingParticipants.jsx';

const Wrapper = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 4px;
  border-radius: 4px;
  min-height: 34px;
  align-items: center;
  padding: 5px;
  color: ${(p) => p.theme.brandSuccess};  
  background-color: ${(p) => p.theme.stateSuccessBg};  
  .slot-action.btn-link {
    color: inherit;
  }
  .slot-action + .slot-action {
    border-left: 1px solid white;
    border-radius: 0;
  }
  &.slot-open {
    color: white;
    background-color: ${(p) => p.theme.brandPrimary};  
  }
  &.slot-break {
    color: ${(p) => p.theme.gray};  
    background-color: ${(p) => p.theme.grayLighter};  
  }
  &.slot-assigned {
    color: white;
    background-color: ${(p) => p.theme.brandSuccess};  
  }
  &.slot-blocked {
    color: white;
    background-color: ${(p) => p.theme.brandDanger};  
  }
  .ss-delete {
    color: white;
  }
  .ss-lock {
    color: white;
    opacity: 0.5;
    margin-right: 8px;
    font-size: 21px;
  }
`;

const SlotContent = styled.div`
  flex-grow: 1;
  text-align: center;
  .spinner-container {
    max-height: 28px;
  }
`;

function TimeSlot(props) {
  const { event, canRemove, onChange } = props;

  function actionsForPeriod() {
    const actions = [];
    switch (event.status) {
      case SLOT_BREAK:
        actions.push('makeMeeting');
        break;
      case SLOT_OPEN:
        actions.push('makeBreak');
        break;
      default:
        actions.push('addSlot');
        break;
    }
    if (canRemove) {
      actions.push('removeSlot');
    }
    return actions;
  }

  function renderByStatus() {
    switch (event.status) {
      case SLOT_ASSIGNED:
        return (
          <div className="w-100">
            <MeetingParticipants {...event.meeting.details} row />
          </div>
        );
      case SLOT_BLOCKED:
        return (
          <div className="d-flex justify-content-between align-items-center">
            <FormattedMessage {...messages.blocked} />
          </div>
        );
      default: // eslint-disable-line no-fallthrough
    }
    const actions = actionsForPeriod();
    return actions.map((type) => (
      <Button variant="link" key={type} className="py-0 px-3 slot-action" onClick={() => onChange(type)}>
        <FormattedMessage {...messages[type]} />
      </Button>
    ));
  }

  const classes = classNames(['slot-allocate', SLOT_CLASSNAMES[event.status]]);
  return (
    <Wrapper className={classes}>
      <EventTime {...event} className="me-3" />
      <SlotContent>
        {renderByStatus()}
      </SlotContent>
    </Wrapper>
  );
}

TimeSlot.propTypes = {
  event: PropTypes.object,
  canRemove: PropTypes.bool,
  onChange: PropTypes.func,
};

export default TimeSlot;
